import { Color } from "@/protocols/color"

export const convertRGBAObjectToString = ({ r, g, b, a }: Color) => {
	return `rgba(${r}, ${g}, ${b}, ${a || 1})`
}
